import React, { useEffect, useState, useCallback } from "react";
import {IonContent, IonPage, IonIcon, IonButton} from "@ionic/react";
import {chevronBack, chevronForward, download, downloadOutline} from "ionicons/icons";
import useStore from "../../zustand/useStore";
import { actionToGetAllUsersMemberShipData } from "../../apiHelpers/CommonAction";
import { FacebookLoader } from "../../components/Loader/FacebookLoader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const ITEMS_PER_PAGE = 10;

export default function AdminMembershipPage() {
    const [currentPage, setCurrentPage] = useState(1);

    // ✅ Use membership state instead of contribution state
    const { memberShipDataState } = useStore();
    const { memberships, loading, totalCount } = memberShipDataState;

    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetAllUsersMemberShipData(false, { offset: newOffset });
    }, []);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const downloadExcel = () =>{
        // ✅ 1. Sort by ID ascending
        const sortedData = [...memberships].sort((a, b) => a.id - b.id);

        // ✅ 2. Format for Excel (select fields)
        const formattedData = sortedData.map((item) => ({
            ID: item.id,
            'Member ID': item.member_id,
            'Membership Type': item.membership_type,
            'Base Amount': item.base_amount,
            GST: item.gst_amount,
            Name: item.member_name,
            'Email':item.member_email,
            'Phone Number': item.member_phone,
            'Total Amount': item.total_amount,
            'Payment Status': item.payment_status,
            'Razorpay Order ID': item.razorpay_order_id,
            'Razorpay Payment ID': item.razorpay_payment_id,
            'Start Date': item.start_date,
            'End Date': item.end_date,
            'Created At': item.created_at,
            'Updated At': item.updated_at,
        }));

        // ✅ 3. Convert JSON → Worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // ✅ 4. Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Memberships");

        // ✅ 5. Write to Excel & trigger download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "all_memberships_transactions.xlsx");
    }

    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <h2 className="newsletter-heading">All Memberships</h2>
                        {memberships?.length > 0 ?(
                                <button className="newsletter-heading_right " onClick={() => downloadExcel()}>
                                    <IonIcon size={1} icon={downloadOutline}  />
                                    <span>Download</span>
                                </button>
                        )
                         /*   <IonIcon
                                className="add_news_icon"
                                onClick={() => downloadExcel()}
                                icon={download}
                            /> */:""}
                    </div>

                    <div className="newsletter-table-container">
                        <table className="newsletter-table">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Member ID</th>
                                <th>Membership Type</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Start Date</th>
                                <th>End Date</th>

                            </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                [...Array(2)].map((_, idx) => (
                                    <tr key={idx}>
                                        {Array(8)
                                            .fill(null)
                                            .map((__, i) => (
                                                <td key={i}>
                                                    <FacebookLoader type="facebookStyle" item={1} />
                                                </td>
                                            ))}
                                    </tr>
                                ))
                            ) : memberships?.length > 0 ? (
                                memberships.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.member_name}</td>
                                        <td>{item.member_id}</td>
                                        <td>{item.membership_type}</td>
                                        <td>{item.member_email}</td>
                                        <td>{item.member_phone}</td>
                                        <td>₹{item.total_amount}</td>
                                        <td>{item.payment_status || "-"}</td>
                                        <td>
                                            {item.start_date
                                                ? new Date(item.start_date).toLocaleDateString()
                                                : "-"}
                                        </td>
                                        <td>
                                            {item.end_date
                                                ? new Date(item.end_date).toLocaleDateString()
                                                : "Lifetime"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center", padding: "1rem" }}>
                                        No memberships found.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className="pagination_button"
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className="pagination_button"
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
}
